// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3RVjs","signatureButtonsRight":"ModalSign_signatureButtonsRight__1zV5x"};